import React, { useState, useEffect } from "react";
import NavBar from "../components/navbar";
import Banner from "../components/blogbanner";
import Courses from "../components/courses";
import Footer from "../components/footer";
import BlogCards from "../components/blogcards";
export default function Blog() {

    return (
        <div>
            <NavBar/>
            <Banner style={{width:"100%"}}/>
            <BlogCards/>
            <Footer/>
        </div>
    );
};
